const BankPlusSvg = () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
            <path fill="#546EDB" fillRule="evenodd" d="M0 9.778C0 4.378 4.378 0 9.778 0s9.778 4.378 9.778 9.778-4.378 9.778-9.778 9.778S0 15.178 0 9.778Zm10.756-3.911a.978.978 0 0 0-1.956 0V8.8H5.867a.978.978 0 1 0 0 1.956H8.8v2.933a.978.978 0 0 0 1.956 0v-2.933h2.933a.978.978 0 0 0 0-1.956h-2.933V5.867Z" clipRule="evenodd"/>
        </svg>
    )
}

export default BankPlusSvg;